import "../components/twitter-timeline/index";

export interface ITwitterTimelinesJsonP {
  accounts: string[];
}

export default class TwitterPanel {
  anchor: HTMLElement = null;
  private _inited = false;

  async init(anchor: string, accountResourcePath: string): Promise<void> {
    try {
      if (!this._inited) {
        this.anchor = document.querySelector(anchor);
        if (this.anchor) {
          this._inited = true;
          const accounts = await this._loadAccounts(accountResourcePath);
          this._buildPanels(accounts);
        } else {
          console.error(`Twitter Panel - ${anchor} element not found in DOM`);
        }
      }
    } catch (err) {
      throw "Twitter Panel - Not valid anchor";
    }
  }

  private async _loadAccounts(url: string): Promise<string[]> {
    try {
      const fetchRes = await fetch(url);
      if (fetchRes.ok) {
        const accountsString = await fetchRes.text();
        return accountsString.split(",");
      } else {
        return [];
      }
    } catch (err) {
      console.error(err);

      return [];
    }
  }

  private _buildPanels(accounts: string[]): void {
    accounts.forEach((account) => {
      const cccPanel = document.createElement("ccc-panel");
      cccPanel.setAttribute("title", "");
      cccPanel.setAttribute("padding-horizontal", "0");
      //cccPanel.setAttribute("padding-vertical", "0");
      const cccTwitterTimeline = document.createElement("ccc-twitter-timeline");
      cccTwitterTimeline.setAttribute("slot", "component");
      cccTwitterTimeline.setAttribute("account", account);

      cccPanel.append(cccTwitterTimeline);

      this.anchor.append(cccPanel);
    });
  }
}
